import { z } from 'zod';
import { OwnerSchema } from '../owner/owner.js';
export const OwnerRecordNoKeysSchema = z.object({
    owner: OwnerSchema,
    createdBy: z.string(),
    createdOn: z.iso.datetime(),
    modifiedBy: z.string(),
    modifiedOn: z.iso.datetime(),
});
export const OwnerRecordWithKeysSchema = OwnerRecordNoKeysSchema.extend({
    PK: z.string(),
    SK: z.string(),
    'GSI-PK-1': z.string(),
    'GSI-SK-1': z.string(),
});
